import { to_array } from "./to_array"

/**
 * Gets first element of iterable.
 *
 * Converts to array and returns first element.
 *
 * @param any - Array, object, or primitive
 * @returns First element
 *
 * @example
 * ```ts
 * import { first } from "@pdfking/rfunc"
 *
 * first([1, 2, 3]) // 1
 * first({ a: 1, b: 2 }) // 1
 * first(5) // 5
 * ```
 */
export const first = any => to_array(any)[0]
